import { useGetOne } from 'react-admin';
import { matchPath, useLocation } from 'react-router-dom';

export const ApartmentExternalPage = () => {
	const { pathname } = useLocation();
	const match = matchPath({ path: '/apartment/show-page/:id' }, pathname);

	const { data: apartmentData } = useGetOne('properties', {
		id: match?.params.id
	});

	if (!match || !apartmentData) {
		return null;
	}

	return <div>External Page for {apartmentData.name}</div>;
};
